import React from "react";
import footer from "./footer.css"

export default function Footer(){
    
    
    return(
        <div id="footer">
            Copyrights © {new Date().getFullYear()} reserverd to Atul Sanodiya
        </div>
    )
}